export default async function copyToClipboard(
  message,
  link,
  linkType,
  enqueueSnackbar
) {
  // Try Web Share API first (best UX on mobile - shows native share sheet)
  if (navigator.share) {
    try {
      await navigator.share({
        title: `${linkType} on KIP`,
        url: link, // Only share the link, no message text
      });
      // Don't show snackbar - native share sheet handles user feedback
      return;
    } catch (error) {
      // User cancelled share or share failed, fall through to clipboard
      if (error.name === 'AbortError') {
        // User cancelled - don't show error, just return silently
        return;
      }
      console.log('Web Share API failed, trying clipboard:', error);
    }
  }

  // For clipboard, only copy the link (not the message) for cleaner paste
  const textToCopy = link;

  // Fallback to clipboard for desktop or when Web Share isn't available
  try {
    // Try modern Clipboard API (works in Chrome, Firefox, Safari desktop)
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(textToCopy);
      enqueueSnackbar(`${linkType} link has been copied to your clipboard!`);
      return;
    }
  } catch (error) {
    console.log('Clipboard API failed, trying fallback:', error);
  }

  // Fallback for Safari mobile and older browsers
  try {
    // Create a temporary textarea element
    const textArea = document.createElement('textarea');
    textArea.value = textToCopy;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    // Use execCommand for Safari mobile compatibility
    const successful = document.execCommand('copy');
    document.body.removeChild(textArea);

    if (successful) {
      enqueueSnackbar(`${linkType} link has been copied to your clipboard!`);
    } else {
      throw new Error('execCommand copy failed');
    }
  } catch (error) {
    console.error('Failed to copy: ', error);
    enqueueSnackbar('Failed to copy link. Please copy manually.', {
      variant: 'error',
    });
  }
}
